import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import store from '@/store';
import en from "@/langs/en";
import ja from "@/langs/ja";

const messages = {
    // en: en,
    ja: ja,
};

const i18n = new VueI18n({
    locale: store.getters["getLocale"], // set locale
    messages,
    fallbackLocale: 'ja',
    silentTranslationWarn: true,
});
export default i18n;


